export const filterButtonClassName = (isSelected: boolean) =>
  isSelected
    ? "bg-surface-inverse-primary text-text-inverse-primary"
    : "bg-surface-tonal-default text-text-primary hover:bg-surface-tonal-bold";

export const filterButtonTextColor = (isSelected: boolean) =>
  isSelected ? "text-text-inverse-primary" : "text-text-primary";
